/* prettier-ignore */
/**
 * NOTE:
 *
 * This file is automatically generated by Traduki 2.0.
 * DO NOT CHANGE IT BY HAND or your changes will be lost.
 */
//Japanese
export default {
  'townsquare.townsquare-tags.tag': 'タグを削除',
  'townsquare.townsquare-tags.tooltip-usage-count':
    '{usageCount, plural, other {{usageCount,number} 箇所で使用されています}}',
};
